import styled from "styled-components";
import { Slate, } from "@bracket/ui";


export const MiniCard = styled.div`
`;

